<template>
	<div class="container">
		<Header />
		<div class="content">
			<div class="table">
				<div class="title">合作单位</div>
				<div class="table_content">
					<el-table :data="tableData" border class="unit_table">
						<el-table-column prop="id" label="序号" width="80"></el-table-column>
						<el-table-column prop="unitName" label="合作单位名称" width="150"></el-table-column>
						<el-table-column prop="contactName" label="联系人" width="140"></el-table-column>
						<el-table-column prop="contactPhone" label="联系电话" width="160"></el-table-column>
						<el-table-column prop="startDate" label="合作生效日期" width="180"></el-table-column>
						<el-table-column prop="status" label="合作状态" width="120">
							<template slot-scope="scope">
								<span :class="scope.row.status === 1 ? 'text_success' : 'text_disable'">
								  {{ scope.row.status === 1 ? "正常" : "已终止" }}
								</span>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="110">
							<template slot-scope="scope">
								<el-button v-if="false" type="text" @click="openEdit(scope.row)">编辑</el-button>
								<el-button type="text" @click="openView(scope.row)">查看</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
		<el-dialog
			title="合作单位信息"
			:visible="dialogVisible"
			width="620px"
			top="26vh"
			@close="closeDialog"
		>
			<el-form :model="formData" label-width="120px">
				<el-form-item label="合作单位名称">
					<el-input v-model="formData.unitName"></el-input>
				</el-form-item>
				<el-form-item label="联系人">
					<el-input v-model="formData.contactName"></el-input>
				</el-form-item>
				<el-form-item label="联系电话">
					<el-input v-model="formData.contactPhone"></el-input>
				</el-form-item>
				<el-form-item label="合作生效日期">
					<el-date-picker v-model="formData.startDate" type="date" placeholder="选择日期"></el-date-picker>
				</el-form-item>
				<el-form-item label="合作状态">
					<el-radio-group v-model="formData.status">
						<el-radio :label="1">正常</el-radio>
						<el-radio :label="0">已终止</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeDialog">取消</el-button>
				<el-button type="primary" @click="saveForm">保存</el-button>
			</div>
		</el-dialog>
		<Footer />
	</div>
</template>

<script>
	import Header from "../../components/common/Header";
	import Footer from "../../components/common/Footer";
	import api from "../../axios/interface";
	export default {
		name: "UnitManage",
		data() {
			return {
				dialogVisible: false,
				tableData: [],
				formData: {
					id: null,
					unitName: "",
					contactName: "",
					contactPhone: "",
					startDate: "",
					status: 1
				}
			};
		},
		components: {
			Header,
			Footer
		},
		mounted() {
			this.getList();
		},
		methods: {
			getList() {
				// this.$axios.get(api.UnitList, {}, { hideMessage: true }).then(res => {
				//   this.tableData = res.result.data;
				// })
				this.tableData = [
					{
						id: 1,
						unitName: "知联合作点",
						contactName: "方*莲",
						contactPhone: "134****0536",
						startDate: "2021-05-11",
						status: 1
					},
					{
						id: 2,
						unitName: "春江合作点",
						contactName: "蒋*敏",
						contactPhone: "137****8570",
						startDate: "2021-08-06",
						status: 1
					},
					{
						id: 3,
						unitName: "桂花路合作点",
						contactName: "*欣",
						contactPhone: "135****6280",
						startDate: "2023-10-12",
						status: 0
					},
					{
						id: 4,
						unitName: "新登富邦合作点",
						contactName: "徐*菲",
						contactPhone: "159****2792",
						startDate: "2024-03-01",
						status: 1
					},
					{
						id: 5,
						unitName: "松溪合作点",
						contactName: "*潇",
						contactPhone: "187****6077",
						startDate: "2025-01-06",
						status: 1
					},
					{
						id: 6,
						unitName: "富阳十小合作点",
						contactName: "钱*雨",
						contactPhone: "137****9285",
						startDate: "2026-04-09",
						status: 1
					},
				];
			},
			openEdit(row) {
				this.formData = { ...row };
				this.dialogVisible = true;
			},
			openView(row) {
				this.formData = { ...row };
				this.dialogVisible = true;
			},
			saveForm() {
				// 保存接口
				this.dialogVisible = false;
				this.getList();
			},
			closeDialog() {
				this.dialogVisible = false;
			}
		}
	};
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		height: 100vh;
		overflow: hidden;
	}
	.content {
		width: 1056px;
		margin: 90px 50px 0 50px;
		height: auto;
		text-align: center;
		padding-bottom: 30px;
		border-radius: 10px;
		background: #fff;
		display: flex;
		flex-direction: column;
	}
	.content .table {
		/*width: 960px;*/
		height: auto;
		margin: 0 48px;
		.title {
			height: 45px;
			line-height: 45px;
			text-align: center;
			font-size: 32px;
			color: #4d4d4d;
			margin-top: 70px;
			margin-bottom: 30px;
		}
		.table_content {
			border-radius: 5px;
		}
	}
	.unit_table {
		thead {
			tr > th {
				.cell {
					color: #333333;
					font-weight: 500;
				}
			}
		}
		td,
		th.is-leaf {
			border-bottom: 1px solid #eeeeee;
		}
	}
	.text_success {
		color: #0079fe;
	}
	.text_disable {
		color: #999;
	}
	.dialog-footer {
		text-align: right;
	}
</style>
